import { combineReducers } from "redux";
// import { DoctorComment } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  FETCH_COMMENTS_DOCTORS_LIST_REQUEST,
  FETCH_COMMENT_DOCTOR_REQUEST,
  UPDATE_COMMENT_DOCTOR_STATUS_REQUEST,
  ADD_FILTER_VALUES_FOR_COMMENTS_DOCTORS,
} from "./constants";
import { Action, CommentListDoctorsState, CommentDoctorState, CommentsDoctorsFilter } from "./types";

function items(
  state: CommentListDoctorsState = { current_page: 0, page_count: 1, data: [] },
  action: Action
): CommentListDoctorsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMENTS_DOCTORS_LIST_REQUEST):
      return {
        ...action.payload,
        data: action.payload.current_page === 1 ? [...action.payload.data] : [...state.data, ...action.payload.data],
      };

    case getSuccessActionType(UPDATE_COMMENT_DOCTOR_STATUS_REQUEST):
      return {
        ...state,
        data: state.data.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                assistant_comment_status: action.payload.data.assistant_comment_status,
              }
            : comment
        ),
      };

    default:
      return state;
  }
}

function comment(state: CommentDoctorState = { isFetching: false, data: {} }, action: Action): CommentDoctorState {
  switch (action.type) {
    case FETCH_COMMENT_DOCTOR_REQUEST:
      return { ...state, isFetching: true };

    case getSuccessActionType(FETCH_COMMENT_DOCTOR_REQUEST):
      return { data: action.payload.data, isFetching: false };

    case getFailureActionType(FETCH_COMMENT_DOCTOR_REQUEST):
      return { data: {}, isFetching: false };

    case UPDATE_COMMENT_DOCTOR_STATUS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case getSuccessActionType(UPDATE_COMMENT_DOCTOR_STATUS_REQUEST):
      return {
        ...state,
        data: { ...state.data, assistant_comment_status: action.payload.data.assistant_comment_status },
        isFetching: false,
      };

    case getFailureActionType(UPDATE_COMMENT_DOCTOR_STATUS_REQUEST):
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
}

function commentsDoctorsFilterValues(state: CommentsDoctorsFilter = {}, action: Action): CommentsDoctorsFilter {
  switch (action.type) {
    case ADD_FILTER_VALUES_FOR_COMMENTS_DOCTORS:
      return action.data;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COMMENTS_DOCTORS_LIST_REQUEST:
    case FETCH_COMMENT_DOCTOR_REQUEST:
      return true;
    case getSuccessActionType(FETCH_COMMENTS_DOCTORS_LIST_REQUEST):
    case getFailureActionType(FETCH_COMMENTS_DOCTORS_LIST_REQUEST):
    case getSuccessActionType(FETCH_COMMENT_DOCTOR_REQUEST):
    case getFailureActionType(FETCH_COMMENT_DOCTOR_REQUEST):
      return false;

    default:
      return state;
  }
}

export const commentsDoctors = combineReducers({ items, comment, isFetching, commentsDoctorsFilterValues });
